/** Display labels only; actual privileges are checked by server/Supabase. */
export function pilotDeviceStateLabel(state){
 if(state==='pending_pairing')return 'Aguardando pareamento físico';
 if(state==='active')return 'Ativo e pareado';
 if(state==='revoked')return 'Revogado';
 return 'Desabilitado';
}
